import {
  BiocyclePhasePopulatedListDto,
  BiocyclePhasesDto,
} from "api/dtos/BiocycleDto";
import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";
import { constructSearchParams } from "utils/constructSearchParams";
import moment from "moment";
import { DATE_FORMAT } from "constants/dateFormat";

const getAllBiocyclePhasesStresses = async (fieldId, options = {}) => {
  try {
    const res = await axiosInstance.get(
      `${URLS.externalRequests}/agro/crops/get-biocyclephases-stresses/?field_id=${fieldId}`,
      options,
    );
    const data = BiocyclePhasePopulatedListDto.fromApi(res.data);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

const getBiocyclePlanForWeatherAnalyticData = (id) => {
  return axiosInstance(`${URLS.externalRequests}/seasons/${id}/analytics/`);
};

// const getBiocyclePlanForCarbonFootprintAndWaterConsumption = async (
//   fieldId
// ) => {
//   try {
//     const res = await axiosInstance(`${URLS.externalRequests}/seasons/`, {
//       params: {
//         field_id: fieldId,
//       },
//     });
//     const bioCycles = BiocycleDto.fromApi(res.data);
//     return { ...res, data: bioCycles };
//   } catch (error) {
//     if (error.response?.status === 404) {
//       return { data: [] };
//     }
//     console.error(error);
//     throw error;
//   }
// };

const getBioPhases = async ({
  fieldId,
  cropId,
  startDate: propsStartDate,
  endDate: propsEndDate,
  cutoff,
}) => {
  const url = `${URLS.externalRequests}/agro/phases/`;
  const startDate = moment(propsStartDate).format(DATE_FORMAT);
  const endDate = moment(propsEndDate).format(DATE_FORMAT);

  const params = constructSearchParams({
    fieldId,
    cropId,
    startDate,
    endDate,
    cutoff,
  });
  try {
    const res = await axiosInstance(url, {
      params,
    });
    const data = BiocyclePhasesDto.fromApi(res.data);
    return data;
  } catch (error) {
    if (error.response?.status === 404) {
      return { data: [] };
    }
    console.error(error);
    throw error;
  }
};

const getActionPlanStatistics = async ({
  cropIds = [],
  cropId,
  date,
  applications,
  type,
} = {}) => {
  const normalizedCropId =
    Array.isArray(cropIds) && cropIds.length > 0 ? cropIds[0] : cropId;

  const params = constructSearchParams({
    cropId: normalizedCropId,
    date,
    applications,
    type,
  });

  const res = await axiosInstance.get(
    `${URLS.statistics}/camvio-action-plan/`,
    {
      params,
    },
  );

  return res;
};

export const biocycleApi = {
  bioPhases: getBioPhases,
  biocyclePhasesStresses: getAllBiocyclePhasesStresses,
  dashboardActionPlan: {
    fetch: getActionPlanStatistics,
  },
  getBiocyclePlanForWeatherAnalyticData: getBiocyclePlanForWeatherAnalyticData,
};
